export default __webpack_public_path__ + "static/CleanEnergySupply-30589a7b90e7e1c979570367887f261e.jpg";